import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import classnames from "classnames";

const ImageGallery = ({ items }) => {
  const [toggler, setToggler] = useState(false);

  return (
    <>
      <div className="flex flex-wrap">
        {items
          .filter(({ image }) => Boolean(image.url))
          .map(({ image }, index) => (
            <img
              className={classnames("cursor-pointer p-3 self-center mx-auto", {
                "w-64": image.dimensions.width > image.dimensions.height,
                "h-64": image.dimensions.width < image.dimensions.height
              })}
              src={image.thumbnails.thumbnail.url}
              onClick={() => setToggler(!toggler)}
              key={index}
            />
          ))}
      </div>
      <FsLightbox
        toggler={toggler}
        sources={items.map(item => item.image.url)}
      />
    </>
  );
};

export default ImageGallery;
